// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5c6a9823","455":"85c76273"}[chunkId] + ".chunk.js";
};